<template>
  <div>
    <p class="clearfix"></p>
    <!-- <general-top-bar :title="$t('newsletterCard.titleMonthlyInfo')"></general-top-bar> -->
    <!-- <div class="category-top-bar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="() => {$router.push('/newsletter')}">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
      </div>
    </div> -->
    <div class="card">
      <div class="card-content">
        <el-table
          :data="items"
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column
            prop="name"
            :label="$t('newsletterCard.tableName')"
          ></el-table-column>
          <el-table-column
            prop="date"
            :label="$t('newsletterCard.tableDate')"
            :width="200"
          ></el-table-column>
          <el-table-column
            :label="$t('newsletterCard.tableDownload')"
            :width="200"
          >
            <template slot="default" slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                class="dld-btn"
                @click.stop="handleDownload(scope.row)"
              >{{ $t('newsletterCard.buttonDownload') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="active-pagination"
        :current-page.sync="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="prev, pager, next, total"
        @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination } from 'element-ui'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import 'element-ui/lib/theme-chalk/index.css'

export default {
  components: {
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElButton: Button,
    ElPagination: Pagination
    // GeneralTopBar
  },
  data () {
    return {
      items: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created () {
    this.fetchPdfFiles()
  },
  methods: {
    async handlePageChange (page) {
      this.pagination.currentPage = page
      await this.fetchPdfFiles()
    },
    async fetchPdfFiles () {
      try {
        let data = {
          token: this.$session.get('token'),
          limit: this.pagination.pageSize,
          skip: (this.pagination.currentPage - 1) * this.pagination.pageSize
        }
        this.apiRequest('/pdf-files-monthly-info', 'GET', data, (response) => {
          if (response.status === true) {
            this.items = response.data
            this.pagination.total = response.total
            this.pagination.currentPage = response.currentPage || 1
          }
        })
      } catch (error) {
        console.error('Error fetching PDF files (Catch):', error.response) // Log the error response
      }
    },
    handleDownload (row) {
      const API_BASE_URL = process.env.API_BASE_URL
      const pdfUrl = `${API_BASE_URL}pdf-monthly-info/${encodeURIComponent(row.name)}`
      window.open(pdfUrl, '_blank')
    },
    handleRowClick (row) {
      this.handleDownload(row)
    }
  }
}
</script>

<style scoped>
.dld-btn {
  border-radius: 20px;
  box-sizing: border-box;
  border-width: 1px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 7px 18px;
  border-color: #66615B;
  color: #66615B;
  -webkit-transition: all 150ms linear;
  -moz-transition: all 150ms linear;
  -o-transition: all 150ms linear;
  -ms-transition: all 150ms linear;
  transition: all 150ms linear;
  background: #027e02;
  color: #fff;}
.arrow-icon {
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Newsletter/Tabs/MonthlyInfo.vue